import { useState } from "react";
import Link from "next/link";
import { ChevronDown } from "lucide-react";

interface PhoneMenuProps {
  menu?: any[];
  direction?: string;
  basePath?: string;
}

export const PhoneMenu = ({ menu = [], direction = 'auto', basePath }: PhoneMenuProps) => {
  const resolvePath = (path: string) => {
    if (!path) return '#';
    if (path.startsWith('http')) return path;
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    if (basePath) {
      const normalized = basePath.endsWith('/') ? basePath.slice(0, -1) : basePath;
      if (!cleanPath.startsWith(normalized)) return `${normalized}${cleanPath}`;
    }
    return cleanPath;
  };

  const navMenu = menu.length > 0 ? menu : [
    { title: 'الرئيسية', path: '/' },
    { title: 'جميع المنتجات', path: '/search' },
    { title: 'تخفيضات', path: '/search?q=sale' },
  ];

  return (
    <div
      className="flex flex-col h-full bg-background"
      dir={direction === 'auto' ? undefined : (direction as any)}
    >
      <div className="p-6 border-b">
        <div className="h-8 w-px bg-primary invisible" /> {/* Spacer */}
      </div>
      <nav className="flex flex-col overflow-y-auto">
        {navMenu.map((item) => (
          <MobileNavItem key={item.title} item={item} resolvePath={resolvePath} />
        ))}
      </nav>
    </div>
  );
};

function MobileNavItem({ item, resolvePath }: { item: any; resolvePath: (p: string) => string }) {
  const [isOpen, setIsOpen] = useState(false);
  const hasChildren = item.children && item.children.length > 0;

  return (
    <div className="border-b border-border/50">
      <div className="flex items-center justify-between">
        <Link
          href={resolvePath(item.path)}
          className="flex-1 py-4 px-6 text-base font-medium hover:bg-accent/5 transition-colors"
        >
          {item.title}
        </Link>
        {hasChildren && (
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="px-6 py-4 text-muted-foreground"
          >
            <ChevronDown className={`h-4 w-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
          </button>
        )}
      </div>

      {hasChildren && isOpen && (
        <div className="bg-accent/5 pb-2">
          {item.children.map((child: any) => (
            <Link
              key={child.title}
              href={resolvePath(child.path || child.url)}
              className="block py-3 px-10 text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              {child.title}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
